import { Chip } from "@mui/material";
import { JobSearchResult } from "@/dentlab/src/store/Search/types";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { ResultCard } from "./SearchResultCard";
import { JobDocumentTags } from "@/dentlab/src/pages/job-page/job-document/job-document-tag.component";
import { JobWithShare } from "@/lib/supabase/supabaseTypes";
import { getClientDisplayName } from "@/lib/utils/client-utils";

export const JobResultCard: React.FC<{ job: JobSearchResult }> = ({ job }) => {
	const navigate = useNavigate();
	const client =
		useCentralStore.getState().clientsLookup[job.client_id as string];
	return (
		<ResultCard
			onClick={() => {
				navigate(`/client/${job.client_id}/job/${job.id}`);
			}}
		>
			<Chip label={job.code} size="small" color="info" />
			<Chip
				label={getClientDisplayName(client)}
				size="small"
				color="secondary"
			/>
			<JobDocumentTags job={job as unknown as JobWithShare} />
			<div className="text-lg">{job?.title}</div>
		</ResultCard>
	);
};
